// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--39FCV";
export var inputGroupLg = "styles-module--input-group-lg--1ICSr";
export var sidebar = "styles-module--sidebar--HmR6U";
export var imageWrapper = "styles-module--image-wrapper--bj_yz";
export var deepSky = "styles-module--deepSky--21_83";
export var starScape = "styles-module--starScape--2kItg";
export var solarSystem = "styles-module--solarSystem--4U1BL";
export var events = "styles-module--events--3XmtD";
export var image = "styles-module--image--26S07";